import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmrReadyProviderPage } from './emr-ready-provider.page';

const routes: Routes = [
  {
    path: '',
    component: EmrReadyProviderPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmrReadyProviderPageRoutingModule {}
